<template>
  <div class="l-auth-container">
    <h1>yesloyal Business Login</h1>
    <a-tabs defaultActiveKey="1" >
      <a-tab-pane key="1">
      <span slot="tab" >
        <a-icon type="login" />
        Login
      </span>

        <a-card class="l-auth">
          <a-form>
            <a-form-item label="Email"
                         :label-col="{ span: 5 }"
                         :wrapper-col="{ span: 12 }">
              <a-input
                name="email"
                v-validate="'required'"
                v-model="credentials.email">
              </a-input>
            </a-form-item>
            <a-form-item :label-col="{ span: 5 }"
                         :wrapper-col="{ span: 12 }"
                         label="Password">
              <a-input
                name="password"
                type="password"
                v-validate="'required'"
                v-model="credentials.password">
              </a-input>
            </a-form-item>
            <div style="display: flex;justify-content: space-between;max-width: 450px;">
              <a-button class=""
                        style="margin: 0;"
                        type="primary"
                        @click="login()">
                Login
              </a-button>
<!--              <a-button class="">-->
<!--                Forgot Password-->
<!--              </a-button>-->
            </div>
          </a-form>
        </a-card>

      </a-tab-pane>
<!--      <a-tab-pane key="2">-->
<!--      <span slot="tab">-->
<!--        <a-icon type="user-add" />-->
<!--        Sign Up-->
<!--      </span>-->

<!--        <a-card class="l-auth">-->
<!--          <a-form>-->
<!--            <a-form-item label="Email"-->
<!--                         :label-col="{ span: 5 }"-->
<!--                         :wrapper-col="{ span: 12 }">-->
<!--              <a-input-->
<!--                name="email"-->
<!--                v-validate="'required'"-->
<!--                v-model="credentials.email">-->
<!--              </a-input>-->
<!--            </a-form-item>-->
<!--            <a-form-item :label-col="{ span: 5 }"-->
<!--                         :wrapper-col="{ span: 12 }"-->
<!--                         label="Password">-->
<!--              <a-input-->
<!--                name="password"-->
<!--                type="password"-->
<!--                v-validate="'required'"-->
<!--                v-model="credentials.password">-->
<!--              </a-input>-->
<!--            </a-form-item>-->
<!--            <div style="display: flex;justify-content: space-between;max-width: 450px;">-->
<!--              <a-button class=""-->
<!--                        style="margin: 0;"-->
<!--                        type="primary"-->
<!--                        @click="signUp()">-->
<!--                Sign Up-->
<!--              </a-button>-->
<!--            </div>-->
<!--          </a-form>-->
<!--        </a-card>-->

<!--      </a-tab-pane>-->
    </a-tabs>
  </div>
</template>
<script>
import Authentication from './Authentication'

// import { PREFIX } from '../../../constants'
export default {
  name: 'Authentication',
  data () {
    return {
      snackbar: false,
      validLogin: false,
      validSignUp: false,
      signUpVisible: false,
      loginPasswordVisible: false,
      signUpPasswordVisible: false,
      // rules: [ (value) => !!value || 'This field is required' ],
      credentials: {
        email: '',
        password: '',
      },
      newUser: {
        username: '',
        password: '',
      },
      message: '',
    }
  },
  methods: {
    submitAuthentication () {
      Authentication.authenticate(this, this.credentials)
    },
    signUp () {
      this.$router.push('Registration')
    },
    login () {
      this.$store.dispatch('auth/login', this.credentials)
    },
  },
}
</script>

<style lang="scss">
  @import "./../../assets/styles";
  .l-auth-container {
    text-align: center;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    background: #fff
  }

  .l-auth, .ant-tabs {
    padding: 15px;
    width: 100%;
    max-width: 600px;
    margin: 45px auto;
  }
  @media screen and (max-width: 800px) {
    .ant-tabs-bar {
      border: 0;
    }
    h1{
      font-size: 27px;
    }
    .l-auth, .ant-tabs{
      width: 100%;
      max-width: 450px;
    }
    .ant-card-body {
      padding: 0;
    }
    .ant-layout {
      padding: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Authentication/Authentication.vue